import {Routes} from '@angular/router';
import {isActiveGuard} from '../guards/is-active.guard';

export const customersRoutes: Routes = [
  {
    path: 'customers',
    loadComponent: () => import('../pages/customers/customers-overview/customers-overview.component').then(m => m.CustomersOverviewComponent),
  }, {
    path: 'customers/import',
    loadComponent: () => import('../pages/customers/customers-import/customers-import.component').then(m => m.CustomersImportComponent),
    canActivate: [isActiveGuard]
  }, {
    path: 'customers/import-fidmanager',
    loadComponent: () => import('../pages/customers/customers-import-fidmanager/customers-import-fidmanager.component').then(m => m.CustomersImportFidmanagerComponent),
    canActivate: [isActiveGuard]
  }, {
    path: 'customers/form',
    loadComponent: () => import('../pages/customers/customer-create/customer-create.component').then(m => m.CustomerCreateComponent),
    canActivate: [isActiveGuard]
  }, {
    path: 'customers/form/:id',
    loadComponent: () => import('../pages/customers/customer-create/customer-create.component').then(m => m.CustomerCreateComponent),
    canActivate: [isActiveGuard]
  }, {
    path: 'customers/:id',
    loadComponent: () => import('../pages/customers/customer-detail/customer-detail.component').then(m => m.CustomerDetailComponent),
  }
];
